function ParticipantNotes($el)
{
    this.$el = $el;
    this.$modal = this.$el.find('.modal');
    this.currentLink = null;

    this.$spinner = $('<i></i>', {
        'class' : 'fa fa-spinner fa-spin',
        'style' : 'margin-right:10px;'
    });

    this.events();
}

ParticipantNotes.prototype.events = function()
{
    var self = this;

    this.$el.on('click', '.delete-link', function(e){
        e.preventDefault();
        self.currentLink = $(this).attr('href');
        self.$modal.modal('show');
    });

    this.$modal.on('click', '.btn-primary', function(){
        $(this).prepend(self.$spinner);
        window.location = self.currentLink;
    });
}

$(document).ready(function(){
    var $container = $('[data-note-list]');
    if($container.length == 1)
        new ParticipantNotes($container);
});